import React, { useEffect, useState } from "react";
import { Col, FormGroup, Label } from "reactstrap";
import { MetaTags } from "react-meta-tags";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { comAddPageFieldFunc, formValid, initialFiledFunc, onChangeSelect } from "../../../components/Common/validationFunction";
import { SaveButton } from "../../../components/Common/CommonButton";
import { breadcrumbReturnFunc, loginCompanyID, loginUserID, metaTagLabel } from "../../../components/Common/CommonFunction";
import { customAlert } from "../../../CustomAlert/ConfirmDialog";
import { C_Select } from "../../../CustomValidateForm";
import SaveButtonDraggable from "../../../components/Common/saveButtonDraggable";
import GlobalCustomTable from "../../../GlobalCustomTable";
import * as mode from "../../../routes/PageMode";
import { getMappingMasterList, saveMappingMaster } from "../../../store/Administrator/MappingMaster/action";
import * as pageId from "../../../routes/allPageID";
import usePartyOptionsFromSetting from "../../../components/Common/CommonPartyOptions";


const MappingMaster = (props) => {
    const dispatch = useDispatch();
    const [pageMode] = useState(mode.defaultsave);
    const history = useHistory()
    const [mappingRows, setMappingRows] = useState([]);
    const [rowIdCounter, setRowIdCounter] = useState(1);
    /* ------------------- FORM FIELDS ------------------- */
    const [originalRows, setOriginalRows] = useState([]);
    const fileds = {
        Division: "",
        Vendor: "",
        Status: { value: 0, label: "Inactive" }
    };
    const [userPageAccessState, setUserAccState] = useState('');
    const [state, setState] = useState(() => initialFiledFunc(fileds));
    const values = { ...state.values };
    const location = { ...history.location }
    const hasShowModal = props.hasOwnProperty(mode.editValue)
    const [addBtnLoading, setAddBtnLoading] = useState(false);
    const { options: commonOptions, loading: vendorLoadingLocal } = usePartyOptionsFromSetting("MappingMasterAPI", pageId.MAPPING_MASTER);

    /* ------------------- REDUX STATE ------------------- */

    const {
        pageField,
        userAccess,
        divisionLoading,
        mappingList,
        saveBtnLoading,
        postMsg,
        errorMsg,
    } = useSelector((state) => ({
        pageField: state.CommonPageFieldReducer.pageField,
        userAccess: state.Login.RoleAccessUpdateData,
        divisionLoading: state.ItemMastersReducer.divisionApiLoading,
        mappingList: state.MappingMasterReducer.mappingList,
        saveBtnLoading: state.MappingMasterReducer.saveBtnLoading,
        postMsg: state.MappingMasterReducer.postMsg,
        errorMsg: state.MappingMasterReducer.errorMsg,
    }));

    /* ------------------- INITIAL LOAD ------------------- */
    useEffect(() => {
        dispatch(getMappingMasterList());
    }, []);

    // userAccess useEffect
    useEffect(() => {
        let userAcc = null;
        let locationPath = location.pathname;

        if (hasShowModal) {
            locationPath = props.masterPath;
        };

        userAcc = userAccess.find((inx) => {
            return (`/${inx.ActualPagePath}` === locationPath)
        })

        if (userAcc) {
            setUserAccState(userAcc)
            breadcrumbReturnFunc({ dispatch, userAcc });
        };
    }, [userAccess])

    /* ------------------- PAGE FIELD SET ------------------- */

    useEffect(() => {
        if (pageField) {
            const fieldArr = pageField.PageFieldMaster;
            comAddPageFieldFunc({ state, setState, fieldArr });
        }
    }, [pageField]);

    useEffect(() => {
        if (mappingList?.length) {

            const formatted = mappingList.map(item => ({
                id: item.id,

                Division: item.Customer_id,
                DivisionName: item.Customer_Name,

                Vendor: item.Party_id,
                VendorName: item.Party_Name,

                Status: item.Is_Active ? 1 : 0,

                isNew: false // ⭐ mark existing rows
            }));

            setMappingRows(formatted);
            setOriginalRows(formatted); // ⭐ store original copy
            setRowIdCounter(mappingList.length + 1);
        }
    }, [mappingList]);

    useEffect(() => {
        // ✅ SUCCESS MESSAGE
        if (postMsg?.StatusCode === 201 && postMsg?.Status === true) {
            customAlert({
                Type: 1,
                Message: postMsg.Message
            });
            // refresh grid
            dispatch(getMappingMasterList());
            // clear local rows
            setMappingRows([]);
            setOriginalRows([]);
            // reset reducer message
            dispatch({ type: "RESET_MAPPING_MASTER_MSG" });
        }

    }, [postMsg]);

    useEffect(() => {

        if (errorMsg) {

            customAlert({
                Type: 4,
                Message: errorMsg?.Message
            });

            dispatch({ type: "RESET_MAPPING_MASTER_MSG" });
        }

    }, [errorMsg]);

    /* ------------------- SAVE HANDLER ------------------- */

    const SaveHandler = (event) => {
        event.preventDefault();

        let changedRows = [];

        mappingRows.forEach(row => {

            // ✅ NEW ROW
            if (row.isNew) {
                changedRows.push(row);
                return;
            }

            // ✅ CHECK EXISTING ROW CHANGES
            const original = originalRows.find(o => o.id === row.id);
            if (!original) return;

            const isChanged =
                original.Division !== row.Division ||
                original.Vendor !== row.Vendor ||
                original.Status !== row.Status;

            if (isChanged) changedRows.push(row);
        });

        // ✅ NOTHING CHANGED
        if (changedRows.length === 0) {
            customAlert({
                Type: 4,
                Message: "No changes to save"
            });
            return;
        }

        // ✅ BUILD PAYLOAD (YOUR FORMAT)
        const payload = changedRows.map(row => ({
            Is_Active: row.Status === 1,
            Createdby: loginUserID(),
            Updatedby: loginUserID(),
            Company_id: loginCompanyID(),
            Customer_id: row.Division,
            Party_id: row.Vendor
        }));

        dispatch(saveMappingMaster({ jsonBody: JSON.stringify(payload) }));
    };



    /* ------------------- STATUS TOGGLE ------------------- */

    const toggleStatus = (rowId) => {
        setMappingRows(prevRows =>
            prevRows.map(row =>
                row.id === rowId
                    ? { ...row, Status: row.Status === 1 ? 0 : 1 }
                    : row
            )
        );
    };

    const deleteRow = (rowId) => {
        setMappingRows(prevRows =>
            prevRows.filter(row => row.id !== rowId)
        );
    };
    /* ------------------- ADD HANDLER ------------------- */

    const AddHandler = async (e) => {
        e.preventDefault();
        if (!values.Division) {
            customAlert({
                Type: 4,
                Message: "Please select Customer"
            });
            return;
        }
        if (!values.Vendor) {
            customAlert({
                Type: 4,
                Message: "Please select Party"
            });
            return;
        }

        if (!formValid(state, setState)) return;

        setAddBtnLoading(true);

        setTimeout(() => {
            const exists = mappingRows.some(
                row =>
                    row.Division === values.Division.value &&
                    row.Vendor === values.Vendor.value
            );

            if (exists) {
                customAlert({
                    Type: 4,
                    Message: "Duplicate Division & Vendor not allowed"
                });
                setAddBtnLoading(false);
                return;
            }

            const newRow = {
                id: rowIdCounter, // ✅ unique id always
                Division: values.Division.value,
                DivisionName: values.Division.label,
                Vendor: values.Vendor.value,
                VendorName: values.Vendor.label,
                Status: 0,
                isNew: true
            };
            setMappingRows(prev => [...prev, newRow]);
            setRowIdCounter(prev => prev + 1); // increase id
            setAddBtnLoading(false);
        }, 400);
    };


    const tableColumns = [
        { dataField: "VendorName", text: "Party" },
        { dataField: "DivisionName", text: "Customer" },
        {
            dataField: "Status",
            text: "Status",
            formatter: (cell, row) => (
                <div className="form-check form-switch d-flex justify-content-center align-items-center">
                    <input
                        type="checkbox"
                        className="form-check-input"
                        checked={row.Status === 1}
                        onChange={() => toggleStatus(row.id)}
                        style={{
                            cursor: "pointer",
                            transform: "scale(1.6)", // ⭐ bigger toggle
                        }}
                    />
                </div>
            )
        },
        {
            dataField: "Action",
            text: "Action",
            formatter: (cell, row) => (
                <button
                    className="btn btn-sm btn-danger"
                    disabled={row.isNew === false} // ⭐ disable for API rows
                    style={{ cursor: row.isNew ? "pointer" : "not-allowed" }}
                    onClick={() => deleteRow(row.id)}
                >
                    Delete
                </button>
            )
        }
    ];

    return (
        <React.Fragment>
            <MetaTags>{metaTagLabel(userPageAccessState)}</MetaTags>
            {/* ---------- FORM ---------- */}
            <div className="px-2   c_card_header text-black mb-1" >
                <div className="row">
                    {/* Division */}
                    <Col sm="4">
                        <FormGroup className=" mb-2 row mt-3 " >
                            <Label className="col-sm-5 p-2" style={{ width: "42px" }}>Party</Label>
                            <Col sm="6">
                                <C_Select
                                    name="Vendor"
                                    value={values.Vendor}
                                    isLoading={vendorLoadingLocal}
                                    options={commonOptions}
                                    className="react-dropdown"
                                    classNamePrefix="dropdown"
                                    onChange={(hasSelect, evn) =>
                                        onChangeSelect({ hasSelect, evn, state, setState })
                                    }
                                    styles={{
                                        menu: provided => ({ ...provided, zIndex: 2 })
                                    }}
                                />
                            </Col>
                        </FormGroup>
                    </Col>

                    {/* Vendor */}
                    <Col sm="3">
                        <FormGroup className=" mb-2 row mt-3 " >
                            <Label className="col-sm-5 p-2" style={{ width: "68px" }}>Customer</Label>
                            <Col sm="7">
                                <C_Select
                                    name="Division"
                                    value={values.Division}
                                    isLoading={divisionLoading}
                                    options={commonOptions}
                                    className="react-dropdown"
                                    classNamePrefix="dropdown"
                                    onChange={(hasSelect, evn) =>
                                        onChangeSelect({ hasSelect, evn, state, setState })
                                    }
                                    styles={{
                                        menu: provided => ({ ...provided, zIndex: 2 })
                                    }}
                                />
                            </Col>
                        </FormGroup>
                    </Col>

                    {/* Add Button */}
                    <Col sm="4" className="d-flex justify-content-end align-items-center mt-1">
                        <button
                            className="btn btn-primary px-4"
                            disabled={addBtnLoading}
                            onClick={AddHandler}
                        >
                            {addBtnLoading ? (
                                <span className="spinner-border spinner-border-sm"></span>
                            ) : (
                                "Add"
                            )}
                        </button>
                    </Col>

                </div>


            </div>
            {mappingRows.length > 0 && (
                <GlobalCustomTable
                    keyField="id"
                    data={mappingRows}
                    columns={tableColumns}
                    search
                    bordered
                    striped
                    classes="table align-middle table-nowrap table-hover"
                    noDataIndication={
                        <div className="text-danger text-center">
                            No Mapping Available
                        </div>
                    }
                />
            )}
            {/* ---------- SAVE BUTTON ---------- */}
            {mappingRows.length > 0 && (
                <SaveButtonDraggable>
                    <SaveButton
                        pageMode={pageMode}
                        onClick={SaveHandler}
                        module={"MappingMaster"}
                        userAcc={userPageAccessState}
                        isLoading={saveBtnLoading}
                    />
                </SaveButtonDraggable>
            )}
        </React.Fragment>
    );
};

export default MappingMaster;
